export default __webpack_public_path__ + "static/media/fotoHiveAntes.caa8ed0b.png";